import {
  CREATE_MONTHLY_TARGET_FAIL,
  CREATE_MONTHLY_TARGET_START,
  CREATE_MONTHLY_TARGET_SUCCESS,
  CREATE_YEARLY_TARGET_START,
  CREATE_YEARLY_TARGET_SUCCESS,
  CREATE_YEARLY_TARGET_FAIL,
  CREATE_LOB_TARGET_START,
  CREATE_LOB_TARGET_SUCCESS,
  CREATE_LOB_TARGET_FAIL,
  CREATE_COMP_TARGET_START,
  CREATE_COMP_TARGET_SUCCESS,
  CREATE_COMP_TARGET_FAIL,
  GET_EMP_TARGET_START,
  GET_EMP_TARGET_SUCCESS,
  GET_EMP_TARGET_FAIL,
  UPDATE_MONTHLY_TARGET_START,
  UPDATE_MONTHLY_TARGET_SUCCESS,
  UPDATE_MONTHLY_TARGET_FAIL,
  UPDATE_YEARLY_TARGET_START,
  UPDATE_YEARLY_TARGET_SUCCESS,
  UPDATE_YEARLY_TARGET_FAIL,
  GET_YEARLY_TARGET_START,
  GET_YEARLY_TARGET_SUCCESS,
  GET_YEARLY_TARGET_FAIL,
  RESET_TARGET,
  UPDATE_COMP_TARGET_START,
  UPDATE_COMP_TARGET_FAIL,
  UPDATE_COMP_TARGET_SUCCESS,
  GET_MONTHLY_TARGET_START,
  GET_MONTHLY_TARGET_SUCCESS,
  GET_MONTHLY_TARGET_FAIL,
  GET_COMP_TARGET_START,
  GET_COMP_TARGET_SUCCESS,
  GET_COMP_TARGET_FAIL,
  GET_LOB_TARGET_START,
  GET_LOB_TARGET_SUCCESS,
  GET_LOB_TARGET_FAIL,
  UPDATE_LOB_TARGET_START,
  UPDATE_LOB_TARGET_SUCCESS,
  UPDATE_LOB_TARGET_FAIL,
  GET_COM_MONTHLY_START,
  GET_COM_MONTHLY_SUCCESS,
  GET_COM_MONTHLY_FAIL,
  GET_LOB_MONTHLY_START,
  GET_LOB_MONTHLY_SUCCESS,
  GET_LOB_MONTHLY_FAIL,
  GET_LOB_YEARLY_START,
  GET_LOB_YEARLY_SUCCESS,
  GET_LOB_YEARLY_FAIL,
  GET_COM_YEARLY_SUCCESS,
  GET_COM_YEARLY_FAIL,
  GET_MONTHLY_CHART_START,
  GET_MONTHLY_CHART_SUCCESS,
  GET_MONTHLY_CHART_FAIL,
  GET_YEARLY_CHART_START,
  GET_YEARLY_CHART_SUCCESS,
  GET_YEARLY_CHART_FAIL,
  RESET_TARGET_STATES,
} from "./constant"

const initialState = {
  error: "",
  successMsg: "",
  loading: false,
  TargetList: [],
  yearlyTarget: [],
  CompanyTarget: [],
  LOBTarget: [],
  MonthlyCompChart: [],
  yearlyCompChart: [],
  MonthlyLobChart: [],
  yearlyLobChart: [],
  monthlyChart: [],
  yearlyChart: [],
}

const TargetReducer = (state = initialState, action) => {
  switch (action.type) {
    case RESET_TARGET:
      return {
        ...state,
        error: "",
        successMsg: "",
        loading: false,
        TargetList: [],
        yearlyTarget: [],
      }
    case CREATE_MONTHLY_TARGET_START:
      return {
        ...state,
        loading: true,
        error: "",
        successMsg: "",
      }
    case CREATE_MONTHLY_TARGET_SUCCESS:
      return {
        ...state,
        loading: false,
        successMsg: action.payload.message,
      }
    case CREATE_MONTHLY_TARGET_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
      }

    case GET_MONTHLY_TARGET_START:
      return {
        ...state,
        loading: true,
        error: "",
        successMsg: "",
      }
    case GET_MONTHLY_TARGET_SUCCESS:
      console.log(action.payload)
      return {
        ...state,
        loading: false,
        TargetList: action.payload,
      }
    case GET_MONTHLY_TARGET_FAIL:
      return {
        ...state,
        loading: false,
        TargetList: [],
        error: action.payload.message,
      }

    case CREATE_COMP_TARGET_START:
      return {
        ...state,
        loading: true,
        error: "",
        successMsg: "",
      }
    case CREATE_COMP_TARGET_SUCCESS:
      return {
        ...state,
        loading: false,
        successMsg: action.payload.message,
      }
    case CREATE_COMP_TARGET_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
      }
    case GET_COMP_TARGET_START:
      return {
        ...state,
        loading: true,
        error: "",
        successMsg: "",
      }
    case GET_COMP_TARGET_SUCCESS:
      return {
        ...state,
        loading: false,
        CompanyTarget: action.payload,
      }
    case GET_COMP_TARGET_FAIL:
      return {
        ...state,
        loading: false,
        CompanyTarget: [],
        error: action.payload.message,
      }
    case UPDATE_COMP_TARGET_START:
      return {
        ...state,
        loading: true,
        error: "",
        successMsg: "",
      }
    case UPDATE_COMP_TARGET_SUCCESS:
      return {
        ...state,
        loading: false,
        successMsg: action.payload.message,
      }
    case UPDATE_COMP_TARGET_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
      }

    case GET_EMP_TARGET_START:
      return {
        ...state,
        loading: true,
        error: "",
        successMsg: "",
      }
    case GET_EMP_TARGET_SUCCESS:
      return {
        ...state,
        loading: false,
        TargetList: action.payload.targets,
        // successMsg: action.payload.message,
      }
    case GET_EMP_TARGET_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
        TargetList: [],
      }

    case UPDATE_MONTHLY_TARGET_START:
      return {
        ...state,
        loading: true,
        error: "",
        successMsg: "",
      }
    case UPDATE_MONTHLY_TARGET_SUCCESS:
      return {
        ...state,
        loading: false,
        successMsg: action.payload.message,
      }
    case UPDATE_MONTHLY_TARGET_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
      }

    case CREATE_YEARLY_TARGET_START:
      return {
        ...state,
        loading: true,
        error: "",
        successMsg: "",
      }
    case CREATE_YEARLY_TARGET_SUCCESS:
      return {
        ...state,
        loading: false,
        successMsg: action.payload.message,
      }
    case CREATE_YEARLY_TARGET_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
      }
    case GET_YEARLY_TARGET_START:
      return {
        ...state,
        loading: true,
        error: "",
        successMsg: "",
      }
    case GET_YEARLY_TARGET_SUCCESS:
      return {
        ...state,
        loading: false,
        yearlyTarget: action.payload,
      }
    case GET_YEARLY_TARGET_FAIL:
      return {
        ...state,
        loading: false,
        yearlyTarget: [],
        TargetList: [],
        error: action.payload.message,
      }

    case UPDATE_YEARLY_TARGET_START:
      return {
        ...state,
        loading: true,
        error: "",
        successMsg: "",
      }
    case UPDATE_YEARLY_TARGET_SUCCESS:
      return {
        ...state,
        loading: false,
        successMsg: action.payload.message,
      }
    case UPDATE_YEARLY_TARGET_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
      }

    case CREATE_LOB_TARGET_START:
      return {
        ...state,
        loading: true,
        error: "",
        successMsg: "",
      }
    case CREATE_LOB_TARGET_SUCCESS:
      return {
        ...state,
        loading: false,
        successMsg: action.payload.message,
      }
    case CREATE_LOB_TARGET_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
      }

    case GET_LOB_TARGET_START:
      return {
        ...state,
        loading: true,
        error: "",
        successMsg: "",
      }
    case GET_LOB_TARGET_SUCCESS:
      return {
        ...state,
        loading: false,
        LOBTarget: action.payload,
      }
    case GET_LOB_TARGET_FAIL:
      return {
        ...state,
        loading: false,
        LOBTarget: [],
        error: action.payload.message,
      }
    case UPDATE_LOB_TARGET_START:
      return {
        ...state,
        loading: true,
        error: "",
        successMsg: "",
      }
    case UPDATE_LOB_TARGET_SUCCESS:
      return {
        ...state,
        loading: false,
        successMsg: action.payload.message,
      }
    case UPDATE_LOB_TARGET_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
      }

    case GET_COM_MONTHLY_START:
      return {
        ...state,
        loading: true,
        error: null,
      }
    case GET_COM_MONTHLY_SUCCESS:
      return {
        ...state,
        loading: false,
        MonthlyCompChart: action.payload.targets,
      }
    case GET_COM_MONTHLY_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
      }
    case GET_LOB_YEARLY_START:
      return {
        ...state,
        loading: true,
        error: null,
      }
    case GET_COM_YEARLY_SUCCESS:
      return {
        ...state,
        loading: false,
        yearlyCompChart: action.payload.targets,
      }
    case GET_COM_YEARLY_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
      }

    case GET_LOB_MONTHLY_START:
      return {
        ...state,
        loading: true,
        error: null,
      }

    case GET_LOB_MONTHLY_SUCCESS:
      return {
        ...state,
        loading: false,
        MonthlyLobChart: action.payload.targets,
      }
    case GET_LOB_MONTHLY_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
      }

    case GET_LOB_YEARLY_START:
      return {
        ...state,
        loading: true,
        error: null,
      }

    case GET_LOB_YEARLY_SUCCESS:
      return {
        ...state,
        loading: false,
        yearlyLobChart: action.payload.targets,
      }
    case GET_LOB_YEARLY_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
      }

    case GET_MONTHLY_CHART_START:
      return {
        ...state,
        loading: true,
        error: null,
      }
    case GET_MONTHLY_CHART_SUCCESS:
      return {
        ...state,
        loading: false,
       monthlyChart: action.payload,
      }
    case GET_MONTHLY_CHART_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
      }
    
    case GET_YEARLY_CHART_START:
      return {
        ...state,
        loading: true,
        error: null,
      }
    case GET_YEARLY_CHART_SUCCESS:
      return {
        ...state,
        loading: false,
       yearlyChart: action.payload
      }
    case GET_YEARLY_CHART_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload.message,
      }
    case RESET_TARGET_STATES:
      return{
        ...state,
        loading: false,
        error: null
      }
    default:
      return state
  }
}

export default TargetReducer
